<template>
  <div class="enquiry-widget">
    <div class="enquiry-widget__header">
      <div class="enquiry-widget__price">
        <div class="enquiry-widget__price-label">{{$store.getters.language.add_dates_pricing}}</div>
        <div class="enquiry-widget__price-total">{{$store.getters.language.FROM}} €{{ price }}/{{$store.getters.language.day}}</div>
      </div>
      <!--
      <div class="enquiry-widget__period">
        <select v-model="period" @change="updatePrice()">
          <option v-if="has_yearly" value="lowest_for_year">Per Year</option>
          <option value="lowest_for_month">{{$store.getters.language.per_day}}</option>
          <option value="weekrange">{{$store.getters.language.per_week}}</option>
          <option value="monthrange">{{$store.getters.language.per_month}}</option>
        </select>
      </div>
    -->
    </div>
    <div class="enquiry-widget__form">
      <DatePicker @input="fromToDates" :label=$store.getters.language.dates :columns="1" :id="id" :allowMinDate="true" :disabledDates="disabledDates"></DatePicker>
      <div class="enquiry-widget__quote" v-if="quote">
        <div v-show="isPOA" class="enquiry-widget__quote-item">{{$store.getters.language.RATE}} <span>A consultar</span></div>
        <div v-show="!isDisabled && !isPOA" class="enquiry-widget__quote-item">{{$store.getters.language.RATE}} <span>€{{ quote.subtotal }}</span></div>
        <div v-show="!isDisabled && !isPOA" class="enquiry-widget__quote-item" v-if="quote.deposit != 0">Deposit <span>€{{ quote.deposit }}</span></div>
        <div v-show="!isDisabled && !isPOA" class="enquiry-widget__quote-item">{{ quote.vat_label }} <span>€{{ quote.vat }}</span></div>
        <div v-show="!isDisabled && !isPOA" class="enquiry-widget__quote-item" v-if="quote.discount != 0">Retención IRPF <span>-€{{ quote.discount }}</span></div>
        <div v-show="!isDisabled && !isPOA" class="enquiry-widget__quote-box">
          <!--{{$store.getters.language.QUOTE}}-->Total <span>€{{ quote.price }}</span>
        </div>
      </div>
      <ButtonPrimary :title="button.text" :disabled="isDisabled" @buttonClick="sendEnquiry" :fullWidth="true"></ButtonPrimary>
    </div>
    <!--
    <div class="enquiry-widget__footer">
      <div class="enquiry-widget__hightlight">{{$store.getters.language.note}}</div>
      <a href="#" @click.prevent="openModal($store.getters.language.this_space_needs)">{{$store.getters.language.liability}}</a>
      <a v-show="this.current_locale == 'es'" href="#" @click.prevent="openModal($store.getters.language.stage_info)">{{$store.getters.language.staged_payments}}</a>
    </div>
  -->
    <SpacesModal v-if="modal.visible" @close="modal.visible = false, modal.description = null" :description="modal.description"></SpacesModal>

  </div>
</template>

<script>
import DatePicker from "../../components/global/DatePickerDropdown"
import axios from 'axios'
import SpacesModal from "../../components/search/SpacesModal"
import ButtonPrimary from "../../components/global/ButtonPrimary"

export default {
  name: 'EnquiryWidget',
  data: () => ({
    range: {},
    price: null,
    quote: null,
    current_locale: null,
    isDisabled: true,
    isPOA: false,
    period: 'lowest_for_year',
    button: {
      text: ''
    },
    disabledDates: [],
    modal: {
      visible: false,
      description: null
    }
  }),
  props: {
    id: {
      default: null,
      type: String
    },
    has_yearly: {
      default: null,
      type: Boolean
    },
    user: {
      default: null,
      type: [String, Number]
    }
  },
  components: {
    DatePicker,
    SpacesModal,
    ButtonPrimary
  },
  mounted () {
    this.updatePrice()
    this.current_locale = current_locale;
    this.button.text = this.$store.getters.language.request_space // this.$store.getters.language.request_this_space
    this.setDisabledDates()
  },
  methods: {
     setDisabledDates () {
      const response = axios
      .get('/api/bookings/get_calendar_data_for_space?listing_id='+this.id)
      .then(response => {
        response.data.forEach((item) => {
            this.disabledDates.push(new Date(item))
        })
      })
     },
     openModal (description) {
        this.modal.visible = true
        this.modal.description = description
     },
    updatePrice () {
      var self = this
      var token = document.head.querySelector("[name=csrf-token]").content
      var data = {
        listing_id: this.id,
        return_type: this.period
      }
      axios.get('/rent/update_top_price.js',
        { params: data },
        { headers: {
                'Content-type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': token
            }
        }).then(response => {
          self.price = response.data.price
          self.$emit('fromPrice', response.data.price)
      })
    },
    fromToDates (range) {
      console.log(range)
      this.range = range
      this.getQuote()
    },
    sendEnquiry () {
      var self = this
      self.button.text = "Loading..."
      var token = document.head.querySelector("[name=csrf-token]").content
      var data = {
        is_vue: 'true',
        status: 'pending1',
        listing_id: this.id,
        from_date: this.range.start,
        to_date: this.range.end,
        quote: this.quote.price,
      }

      console.log(data)

      axios.post('/bookings',
        data,
        { headers: {
                'Content-type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': token
            }
        }).then(response => {
          console.log(response.data.status)
          if (response.data.status == 'created'){
            window.location.href = '/search/cart';
          }else{
            self.button.text = "Error sending"
          }
      })
    },
    getQuote () {
    var self = this
    var token = document.head.querySelector("[name=csrf-token]").content
    var data = {
      listing_id: this.id,
      return_type: 'range',
      from_date: this.range.start,
      to_date: this.range.end
    }

    if (this.range.start && this.range.end) {
      axios.post('/rent/update_price.js',
        data,
        { headers: {
                'Content-type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest',
                'X-CSRF-Token': token
            }
        }).then(response => {
          self.quote = response.data
          if (self.quote.is_poa){
              self.isPOA = true
          }
          if (self.quote.price == 'booked'){
              self.button.text = "Space Booked"
              self.isDisabled = true
          }else{
              self.button.text = this.$store.getters.language.request_this_space
              self.isDisabled = false
          }
      })
    }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../../scss/global/includes";

.enquiry-widget {
  background-color: $light-grey;
  color: $primary-grey;
  border-radius: 4px;
  overflow: hidden;
  width: 100%;
  padding: 32px;
}

.enquiry-widget__header {
}

.enquiry-widget__form {
  margin-top: 20px;
  .dropdown-datepicker {
    margin: 0 0 8px 0;
  }
}

.enquiry-widget__picker-label {
  @include responsive-text-size('Header--12--LIGHT');
}

.enquiry-widget__price-label {
  @include responsive-text-size('Header--14--BOLD');
}

.enquiry-widget__quote {
  margin: 24px 0;
}

.enquiry-widget__quote-item {
  padding-bottom: 32px;
  width: 100%;
  list-style: none;
  display: grid;
  grid-template-columns: 1fr 1fr;
  span {
    // font-family: $font-bold;
    text-align: right;
  }
}


.enquiry-widget__quote-box {
  padding: 16px 0;
  position: relative;
  overflow: visible;
  height: auto;
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  border-top: 1px solid $divider-dark;
  @include responsive-text-size('Title--18--Regular');

  span {
    // font-family: $font-bold;
    text-align: right;
  }
}

.enquiry-widget__price-total {
  @include responsive-text-size('Body--14--Light');
}

.enquiry-widget__period {
  select {
    font-family: $font-bold;
    font-size: 14px;
    letter-spacing: -0.2px;
    line-height: 1.2;
    color: #FFFFFF;
    background: transparent;
    text-transform: uppercase;
    border: 0;
    width: 100%;
    border-radius: 0;
    outline: none;
  }
}

.enquiry-widget__button {
  height: 50px;
  border-radius: 2px;
  font-family: $font-bold;
  font-size: 14px;
  letter-spacing: -0.2px;
  line-height: 1.2;
  color: #FFFFFF;
  background: $primary;
  width: 100%;
  text-align: center;
  text-transform: uppercase;
}

.enquiry-widget__hightlight {
  color: $primary;
  font-size: 14px;
  line-height: 1.4;
}

.enquiry-widget__footer {
  padding: 10px 20px 30px 20px;

  a {
    text-decoration: underline;
    display: block;
  }
}

.tooltip {
  display: block !important;
  z-index: 10000;
}

.tooltip .tooltip-inner {
  background: black;
  color: white;
  border-radius: 16px;
  padding: 5px 10px 4px;
}

.tooltip .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: black;
  z-index: 1;
}

.tooltip[x-placement^="top"] {
  margin-bottom: 5px;
}

.tooltip[x-placement^="top"] .tooltip-arrow {
  border-width: 5px 5px 0 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="bottom"] {
  margin-top: 5px;
}

.tooltip[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 5px 5px 5px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -5px;
  left: calc(50% - 5px);
  margin-top: 0;
  margin-bottom: 0;
}

.tooltip[x-placement^="right"] {
  margin-left: 5px;
}

.tooltip[x-placement^="right"] .tooltip-arrow {
  border-width: 5px 5px 5px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip[x-placement^="left"] {
  margin-right: 5px;
}

.tooltip[x-placement^="left"] .tooltip-arrow {
  border-width: 5px 0 5px 5px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -5px;
  top: calc(50% - 5px);
  margin-left: 0;
  margin-right: 0;
}

.tooltip.popover .popover-inner {
  background: #f9f9f9;
  color: black;
  padding: 24px;
  border-radius: 5px;
  //box-shadow: 0 5px 30px rgba(black, .1);
}

.tooltip.popover .popover-arrow {
  border-color: #f9f9f9;
}

.tooltip[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity .15s, visibility .15s;
}

.tooltip[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity .15s;
}

</style>